import React from "react";

const Notfound = () => {
  const styles = {
    body: {
      margin: 0,
      padding: 0,
      width: "100vw",
      height: "100vh",
      fontFamily: "'Arial', sans-serif",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(45deg, #D7C9A1, #B6A878)",
      color: "#000",
      overflow: "hidden",
    },
    container: {
      textAlign: "center",
      color: "#000",
    },
    logo: {
      width: "300px",
      height: "auto",
      marginBottom: "20px",
      filter: "drop-shadow(0 4px 10px rgba(0, 0, 0, 0.5))",
    },
    heading: {
      fontSize: "3rem",
      fontWeight: "bold",
      textTransform: "uppercase",
      letterSpacing: "5px",
      color: "#000",
      textShadow: "2px 2px 10px rgba(0, 0, 0, 0.5)",
    },
    subheading: {
      fontSize: "1.5rem",
      marginTop: "10px",
      color: "#222",
      fontWeight: "500",
      letterSpacing: "2px",
    },
    bubbles: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      zIndex: 1,
      overflow: "hidden",
      background: "rgba(0, 0, 0, 0.6)",
    },
    bubble: {
      position: "absolute",
      bottom: "-50px",
      width: "50px",
      height: "50px",
      background:
        "radial-gradient(circle, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0))",
      borderRadius: "50%",
      animation: "rise 8s infinite ease-in-out",
      opacity: 0.8,
    },
  };

  const bubbleStyles = [
    { left: "10%", animationDelay: "0s" },
    {
      left: "30%",
      animationDelay: "2s",
      width: "70px",
      height: "70px",
      background: "#D7C9A1",
    },
    {
      left: "50%",
      animationDelay: "4s",
      width: "90px",
      height: "90px",
      background: "#B6A878",
    },
    { left: "70%", animationDelay: "6s" },
    {
      left: "90%",
      animationDelay: "8s",
      width: "70px",
      height: "70px",
      background: "#D7C9A1",
    },
  ];

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <img src={ process.env.PUBLIC_URL + "/logo.png"} alt="Alchemy Markets Logo" style={styles.logo} />
        <h2 style={styles.heading}>Oops! 404 Not found!</h2>
        <a
            href="/authpanel/dashboard"
            type="button"
            style={{
                marginTop: '20px',
                backgroundColor: '#007bff',
                color: '#fff',
                padding: '7px 15px',
                fontSize: '14px',
                fontWeight: 500,
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#000000'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = '#000000'}
        >
            Go Back
        </a>
        {/* <div style={styles.bubbles}>
          {bubbleStyles.map((bubbleStyle, index) => (
            <div key={index} style={{ ...styles.bubble, ...bubbleStyle }}></div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default Notfound;
